import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaInstagram, FaFacebook } from 'react-icons/fa';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h4>{t('footer_brand_title')}</h4>
          <p>{t('footer_about_desc')}</p>

        </div>

        <div className="footer-section quick-links">
          <h4>{t('quick_links')}</h4>
          <ul>
            <li><Link to="/">{t('home')}</Link></li>
            <li><Link to="/about">{t('about')}</Link></li>
            <li><Link to="/products">{t('products')}</Link></li>
            <li><Link to="/franchise">{t('franchise')}</Link></li>
            <li><Link to="/contact">{t('contact')}</Link></li>
            <li><a href="/sitemap.xml">Sitemap</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('contact_info')}</h4>
          <p>📍 <span>{t('contact_address_text')}</span></p>
          <p>📧 <a href="mailto:aswadamruttuly@gmail.com" style={{color: 'rgba(255, 255, 255, 0.95)'}}>{t('contact_email_value')}</a></p>
          <div className="footer-contact-icons">
            <a href={`https://wa.me/918668972711`} target="_blank" rel="noopener noreferrer" aria-label={t('whatsapp_label')} title={t('whatsapp_label')}>
              <i className="fab fa-whatsapp" style={{ fontSize: 20, lineHeight: 0 }} aria-hidden="true"></i>
            </a>
            <a href="tel:+918668972711" aria-label={t('call_label')} title={t('call_label')}>
              <i className="fas fa-phone" style={{ fontSize: 18, lineHeight: 0 }} aria-hidden="true"></i>
            </a>
          </div>
          <p style={{ marginTop: '10px', fontSize: '14px' }}>
            Contact us: <a href="tel:+918668972711" style={{ color: 'rgba(255, 255, 255, 0.95)', textDecoration: 'none' }}>+91 8668972711</a>
          </p>
        </div>

        <div className="footer-section">
          <h4>{t('follow_us')}</h4>
          <p>{t('stay_updated')}</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/aswad_amruttuly" target="_blank" rel="noopener noreferrer" title={t('instagram_label')} aria-label={t('follow_on_instagram')}>
              {React.createElement(FaInstagram as any, { size: 22 })}
            </a>
            <a href="https://www.facebook.com/share/14YMmoeMZ8D/" target="_blank" rel="noopener noreferrer" title={t('facebook_label')} aria-label={t('follow_on_facebook')}>
              {React.createElement(FaFacebook as any, { size: 22 })}
            </a>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <p>&copy; {new Date().getFullYear()} Aswad Amruttulya. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;